<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        v-watermark="{
          text: `${inform.CustName}`,
          textColor: 'rgba(180, 180, 180, 0.5)',
          account: `${inform.CustAccount}`,
        }"
      >
      </router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      v-watermark="{
        text: `${inform.CustName}`,
        textColor: 'rgba(180, 180, 180, 0.5)',
        account: `${inform.CustAccount}`,
      }"
    >
    </router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  computed: {
    inform() {
      //   let test = JSON.parse(this.$store.getters.info || "{}");
      //   debugger;
      let obj = {
        CustName: "",
        CustAccount: "",
      };
      if (this.$store.getters.info) {
        obj = JSON.parse(this.$store.getters.info);
      }

      return obj;
    },
  },
  data: () => ({
    include: [],
    isRouterAlive: true,
  }),

  watch: {
    // $route(to, from) {
    // 	console.log(to, from, "to, from")
    // 	//如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
    // 	if (to.meta.keepAlive) {
    // 		!this.include.includes(to.name) && this.include.push(to.name)
    // 	}
    // 	//如果 要 form(离开) 的页面是 keepAlive缓存的，
    // 	//再根据 deepth 来判断是前进还是后退
    // 	//如果是后退
    // 	if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
    // 		var index = this.include.indexOf(from.name)
    // 		index !== -1 && this.include.splice(index, 1)
    // 	}
    // }
  },

  //   updated() {
  //     let test = this.inform;
  //     let test2 = this.$store.getters.info;
  //     debugger;
  //   },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },

  // created(){
  //  this.$store.dispatch("merchant/getCartNum");
  // },
};
</script>

<style lang="scss">
html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

// :root body {
// 	position: absolute;
// }

// body {
// 	width: 100vw;
// 	overflow: hidden;
// 	height: auto;
// }
// #app {
// 	margin: 0;

// 	padding: 0;

// 	height: auto;
// }
.specialBox {
  .el-checkbox__label {
    font-size: 12px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 36px;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-input--small .el-input__inner {
    // border: none !important;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
    color: #000;
    border-bottom: 1px solid red;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #ff4f1a;
    border-color: #ff4f1a;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #ff4f1a;
  }
  .el-checkbox.is-bordered.is-checked {
    border-color: #ff4f1a;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #ff4f1a;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-input--small .el-input__inner {
    // border: none !important;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #cecece;
  }
}
</style>
